(() => {
  const key = '__aliencellHalloweenMakers';
  if (window[key]) { window[key].init(document); return; }
  const instances = new Map();
  const selector = '[data-halloween-maker-marquee]';
  const init = scope => {
    const roots = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) roots.unshift(scope);
    roots.forEach(root => {
      if (instances.has(root)) return;
      const track = root.querySelector('[data-halloween-maker-track]');
      const group = root.querySelector('[data-halloween-maker-group]');
      if (!track || !group || !track.animate) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const speed = 32; // Screen pixels per second, consistent across viewport widths.
      let animation = null, duration = 0, width = 0;
      let hover = false, focused = false, dragging = null, visible = true;
      const clones = [];
      const update = () => {
        if (!animation) return;
        if (hover || focused || dragging || !visible || document.hidden) animation.pause();
        else animation.play();
      };
      const rebuild = () => {
        const phase = duration ? (Number(animation?.currentTime || 0) % duration) / duration : 0;
        animation?.cancel();
        animation = null;
        clones.splice(0).forEach(clone => clone.remove());
        root.style.overflowX = motion.matches ? 'auto' : 'hidden';
        root.style.touchAction = motion.matches ? 'auto' : 'pan-y';
        root.scrollLeft = 0;
        width = group.getBoundingClientRect().width;
        if (motion.matches || !width || !root.clientWidth) return;
        // One full group stays outside the viewport to make the rightward wrap seamless.
        for (let i = 0; i < Math.ceil(root.clientWidth / width); i++) {
          const clone = group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          track.append(clone);
          clones.push(clone);
        }
        duration = width / speed * 1000;
        animation = track.animate([
          { transform: `translateX(${-width}px)` },
          { transform: 'translateX(0)' }
        ], { duration, iterations: Infinity, easing: 'linear' });
        animation.currentTime = phase * duration;
        update();
      };
      root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hover = true; update(); } }, options);
      root.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hover = false; update(); } }, options);
      root.addEventListener('focusin', () => { focused = root.matches(':focus-visible'); update(); }, options);
      root.addEventListener('focusout', () => { focused = false; update(); }, options);
      root.addEventListener('pointerdown', event => {
        if (!animation || (event.pointerType === 'mouse' && event.button !== 0)) return;
        dragging = { id: event.pointerId, x: event.clientX, time: Number(animation.currentTime || 0) };
        root.setPointerCapture(event.pointerId);
        update();
      }, options);
      root.addEventListener('pointermove', event => {
        if (!dragging || event.pointerId !== dragging.id || !animation) return;
        const time = dragging.time + (event.clientX - dragging.x) / speed * 1000;
        animation.currentTime = ((time % duration) + duration) % duration;
      }, options);
      const release = event => {
        if (!dragging || event.pointerId !== dragging.id) return;
        dragging = null;
        update();
      };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => root.addEventListener(name, release, options));
      root.addEventListener('keydown', event => {
        if (!animation || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        focused = true;
        const time = Number(animation.currentTime || 0) + (event.key === 'ArrowRight' ? -1 : 1) * 240 / speed * 1000;
        animation.currentTime = ((time % duration) + duration) % duration;
        update();
      }, options);
      document.addEventListener('visibilitychange', update, options);
      motion.addEventListener('change', rebuild, options);
      const resize = new ResizeObserver(rebuild);
      resize.observe(root);
      resize.observe(group);
      const intersection = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        update();
      });
      intersection.observe(root);
      rebuild();
      instances.set(root, () => {
        controller.abort();
        resize.disconnect();
        intersection.disconnect();
        animation?.cancel();
        clones.forEach(clone => clone.remove());
        root.style.removeProperty('overflow-x');
        root.style.removeProperty('touch-action');
        instances.delete(root);
      });
    });
  };
  window[key] = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
  });
  init(document);
})();
